<script>
const d = new Date().toLocaleString().replace(/[^\w\d]+/g, "");

export default {
  inject: ["getWorkbook"],
  props: {
    value: {
      type: Object,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    disableWrapperClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  mounted() {
    this.load();
  },
  watch: {
    loaded: {
      immediate: true,
      handler(loaded) {
        if (loaded) {
          this.getWorkbook((wb) => {
            this._workbook = wb;
          });
        }
      },
    },
  },
  methods: {
    async load() {
      const { writeFile } = await import("xlsx");
      this._writeFile = writeFile;
      this.loaded = true;
    },
    download() {
      if (this.value["filename"]) {
        let a = this.value.filename;
        if (!(a && a.length > 0)) a = this.d;
        if (a.lastIndexOf(".xlsx") != a.length - 5) a = a + ".xlsx";
        this._writeFile(this._workbook, this.value.filename, this.options);
      } else
        this._writeFile(
          this._workbook,
          "nitro-stok-sayim-raporu-" + this.d + ".xlsx",
          this.options
        );
    },
  },
  render(h) {
    if (this.$scopedSlots.default && this.loaded) {
      return h(
        "div",
        {
          on: {
            click: this.disableWrapperClick ? () => {} : this.download,
          },
        },
        [
          this.$scopedSlots.default({
            download: this.download,
          }),
        ]
      );
    }
    return null;
  },
};
</script>
